module.exports = __webpack_public_path__ + "img/pamphlet_thumb01@2x.bed20433.png";